import {Component} from '@angular/core';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Router, NavigationEnd} from '@angular/router';
import {AuthService} from "../services/auth.service";
import {MatDialog} from '@angular/material/dialog';
import {Account} from '../models/account';
import {AccountProfileComponent} from '../auth/account-profile/account-profile.component';
import {AccountPasswordComponent} from '../auth/account-password/account-password.component';

@Component({
  selector: 'app-main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: [ './main-nav.component.scss' ]
})
export class MainNavComponent {

  public isHidden: boolean = true;
  public isHandset$: Observable<boolean> = this.display("Web");

  public claims: any = {admin: false, operator: false, user: false}
  public currentUser: any

  public isSbccvStaff: boolean = false;

  public hideToolBar: boolean = false;
  public hideToolBarTop: boolean = false;

  constructor (
    private breakpointObserver: BreakpointObserver,
    public _authService: AuthService,
    private dialog: MatDialog,
    private router: Router
  ) {

    this.router.events.subscribe((event) => {

      if (event instanceof NavigationEnd) {

        if (event.url.includes('/annuity-back') || 
                event.url.includes('/annuity-pay') ) {
          this.hideToolBarTop = true;
        } else {
          this.hideToolBarTop = false;
        }

        if (event.url == '/'
          || event.url == '**'
          || event.url.substring(0, 6) == '/pages'
          || event.url == '/home'
          || event.url == '/tutor'
          || event.url == '/loja'
          || event.url == '/loja2'
          || event.url == '/sign-in'
          || event.url == '/member-login'
          || event.url == '/member-area'
          || event.url == '/member-profile'
          || event.url == '/member-subscriptions'
          || event.url == '/member-certifies'
          || event.url == '/member-agenda'
          || event.url == '/member-categories'
          || event.url == '/member-tpiccv'
          || event.url == '/member-formation'
          || event.url == '/forgot-password'
          || event.url == '/forgot-password'
          || event.url.substring(0, 12) == '/subscribers'
          || event.url.substring(0, 17) == '/knowledge_viewer'

          || event.url.substring(0, 16) == '/confirm_back_v2'
          || event.url.substring(0, 15) == '/update_back_v2'
          || event.url.substring(0, 6) == '/toten'
          || event.url == '/preview'
          || event.url == '/49'
          || event.url == '/50'
          || event.url.substring(0, 15) == '/member-collect'
          || event.url.substring(0, 9) == '/programa'
          //
          || event.url.substring(0, 21) == '/speaker-confirm-back'
          || event.url.substring(0, 20) == '/speaker-update-back'
          || event.url.substring(0, 17) == '/speaker-end-back'
          || event.url.substring(0, 13) == '/annuity-back'
          || event.url.substring(0, 12) == '/annuity-pay'

          /*
          || event.url == '/invite-agenda-dates'
          || event.url == '/invite-agenda-confirm'
          || event.url == '/invite-agenda-itens'
          || event.url == '/invite-agenda-end'
          || event.url == '/invite-confirm-dates'
          || event.url == '/invite-confirm-confirm'
          || event.url == '/invite-confirm-decide'
          || event.url == '/invite-confirm-itens'
          || event.url == '/invite-confirm-end'
          */
          //|| event.url.substring(0, 15) == '/invite_confirm'
          //|| event.url.substring(0, 19) == '/invite_update_data'
          //|| event.url == '/invite_end'
          //|| event.url.substring(0, 17) == '/invite_mail_back'
          //|| event.url.substring(0, 19) == '/invite_agenda_back'
          //|| event.url.substring(0, 19) == '/invite_update_back'
          //|| event.url.substring(0, 20) == '/invite_confirm_back'

        ) {

          if (
            event.url == '/member-login' ||
            event.url == '/member-area' ||
            event.url == '/member-profile' ||
            event.url == '/member-subscriptions' ||
            event.url == '/member-certifies' ||
            event.url == '/member-agenda' ||
            event.url == '/member-categories' ||
            event.url == '/member-tpiccv' ||
            event.url == '/member-formation' ||
            event.url.substring(0, 12) == '/subscribers' ||
            event.url == '/tutor' ||
            event.url == '/loja' ||
            event.url == '/loja2' ||
            event.url.substring(0, 6) == '/toten' ||
            event.url.substring(0, 16) == '/confirm_back_v2' ||
            event.url.substring(0, 15) == '/update_back_v2' ||
            event.url == '/49' ||
            event.url == '/50' ||
            event.url.substring(0, 9) == '/programa' ||
            //
            event.url.substring(0, 21) == '/speaker-confirm-back' ||
            event.url.substring(0, 20) == '/speaker-update-back' ||
            event.url.substring(0, 17) == '/speaker-end-back' ||
            event.url.substring(0, 13) == '/annuity-back' ||
            event.url.substring(0, 12) == '/annuity-pay' ||
            //
            event.url.substring(0, 6) == '/pages' ||
            //
            event.url.substring(0, 15) == '/member-collect') {
            this.hideToolBar = true
          }

          this.isHidden = true;
          this.isHandset$ = this.display('web');
        } else {
          this.isHidden = false;
          this.isHandset$ = this.display('Handset');
        }

      }
    })

  }

  toggle (drawer) {

    let r = this.breakpointObserver.observe(Breakpoints.Handset)
      .pipe(
        map(result => result.matches)
      );

    r.subscribe((e) => {
      if (e) {
        drawer.toggle()
      }
    })

  }

  ngOnInit () {
  }

  display (d) {

    if (d == 'Web') {
      return this.breakpointObserver.observe(Breakpoints.Web)
        .pipe(
          map(result => result.matches)
        );
    } else if (d == 'Handset') {
      return this.breakpointObserver.observe(Breakpoints.Handset)
        .pipe(
          map(result => result.matches)
        );
    }

  }

  showProfile () {

    this.currentUser = this._authService.getLogged()

    let accountData: Account = new Account();
    accountData.id = this.currentUser.uid
    accountData.email = this.currentUser.email
    accountData.displayName = this.currentUser.displayName
    //accountData.phoneNumber = this.currentUser.phoneNumber
    accountData.photoURL = this.currentUser.photoURL

    this.dialog.open(AccountProfileComponent, {
      width: '800px',
      height: '600px',
      panelClass: 'custom-dialog-container',
      data: accountData
    });

  }

  showPassword () {

    this.currentUser = this._authService.getLogged()
    let accountData: Account = new Account();

    this.dialog.open(AccountPasswordComponent, {
      width: '500px',
      height: '440px',
      panelClass: 'custom-dialog-container',
      data: accountData
    });
  }
}
